import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { User } from '@/models/user/user';
import { usersService } from '@/services/users';

@Component
export default class UsersList extends Vue {

    users: User[] = []
    fields = [
        { key: 'username' },
        { key: 'createdAt', label: 'Created' },
        {
            key: 'role',
            formatter: (value: string) => value === 'ADMIN' ? 'Administrator' : 'Customer'
        },
        { key: 'action', label: '' }
    ]
    currentPage: number = 1
    totalCount: number = 0
    pageSize: number = 10
    loading = false
    refreshTimer: number = null

    async mounted() {
        await this.refresh()
    }

    async refresh() {
        this.currentPage = 1;
        this.loading = true
        try {
            await this.loadUsers(this.currentPage)
        }
        finally {
            this.loading = false
        }
    }

    async loadUsers(page: number) {
        try {
            const [totalCount, users] = await Promise.all([
                usersService.getTotalCount(),
                usersService.getUsersPage(page, this.pageSize)
            ])
            this.totalCount = totalCount
            this.users = Array.isArray(users) ? users : [users]
        } catch (error) {
            this.$bvToast.toast('Failed to load users', {
                title: 'Error',
                variant: 'danger'
            });
        }
    }

    createUser() {
        this.$router.push('/users/new')
    }

    viewUser(user: User) {
        this.$router.push(`/users/${user.id}`)
    }

    async deleteUser(user: User) {
        if (await this.$confirmWarning(`Are you sure you want to delete User '${user.username}'?`)) {
            await usersService.deleteUser({ resourceId: user.id })
            await this.refresh()
        }
    }
}
